import { render, staticRenderFns } from "./TreeComp.vue?vue&type=template&id=13f52fb7&scoped=true&"
import script from "./TreeComp.vue?vue&type=script&lang=js&"
export * from "./TreeComp.vue?vue&type=script&lang=js&"
import style0 from "./TreeComp.vue?vue&type=style&index=0&id=13f52fb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f52fb7",
  null
  
)

export default component.exports